import React from 'react';
import { Helmet } from 'react-helmet';
import { showIf } from 'react-render-helpers';

import CenteredContent from '../../components/CenteredContent';
import { getHelpfulArticleByPath } from '../../helpers/getHelpfulArticles';
import './HelpfulArticle.scss';

function HelpfulArticle(props) {
  const article = getHelpfulArticleByPath(props.slug);
  return (
    <CenteredContent className="helpful-article">
      <Helmet>
        <meta name="description" content="Helpful Articles" />
        <meta itemprop="description" content="Helpful Articles" />
        <meta property="og:description" content="Helpful Articles" />
      </Helmet>
      {showIf(article)(() => {
        return (
          <div className="helpful-article__content">
            <div className="helpful-article__title">{article.title}</div>
            <div
              className="helpful-article__body"
              dangerouslySetInnerHTML={{ __html: article.__content }}
            ></div>
          </div>
        );
      })}
    </CenteredContent>
  );
}

export default HelpfulArticle;
